import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Loader from "../loader/loader";
import { toastFunction, errorToastFunction } from "../../utils/toast";
import FloatingLabelInput from "../FloatingLabelInput/FloatingLabelInput";
import axios from "axios";
import { backendURL } from "../../utils/backed-url";

const AddVoucherPayment = ({ onCancel, onSuccess = onCancel, clientId }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      setErrorMessage("");

      const paymentData = {
        pin: data.pin.trim(),
        clientId: clientId,
      };

      const response = await axios.post(
        `${backendURL}/v1/api/voucher/remit/`,
        paymentData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        toastFunction(
          "Voucher payment processed successfully",
          "success",
          "voucher-payment-success"
        );
        reset();
        onSuccess();
      } else {
        errorToastFunction("Failed to process voucher payment");
      }
    } catch (error) {
      console.error("Voucher payment error:", error);
      // Access the error message from the response data
      const errMsg =
        error.response?.data?.error || "Failed to process voucher payment";
      setErrorMessage(errMsg);
      errorToastFunction(errMsg);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loader sizeClass={"size--medium"} />;
  }

  return (
    <div className="basic-modal">
      <div className="basic-modal__header">
        <h3>Add Voucher Payment</h3>
      </div>
      <div className="basic-modal__body">
        {errorMessage && (
          <div className="input-container__error">{errorMessage}</div>
        )}
        <form onSubmit={handleSubmit(onSubmit)} className="basic-modal__form">
          <FloatingLabelInput
            type={"text"}
            className={""}
            disabled={false}
            name={"pin"}
            register={register}
            rules={{
              required: "PIN is required",
            }}
            placeholder={"Enter Voucher PIN"}
            errors={errors}
          />

          <div className="basic-modal__footer">
            <button
              type="button"
              onClick={onCancel}
              className="button button--secondary"
            >
              Cancel
            </button>
            <button type="submit" className="button button--primary">
              Process Voucher
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddVoucherPayment;
